import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "react-select/lib/filters";
import AdvanceSelector from "../advance-selector";
import useGetBuildingOptions from "@modules/shared/selectors/hooks/useGetBuildingOptions";

interface AdvancedBuildingSelectorProps {
  scenario: string;
  campusId?: string;
  buildingOption?: Option;
  onChange?: (option: Option) => void;
}

const AdvancedBuildingSelector = ({
  scenario,
  campusId,
  buildingOption,
  onChange,
}: AdvancedBuildingSelectorProps) => {
  const { getBuildingOptions, optionsBuilding } = useGetBuildingOptions({
    scenario,
    campusId,
  });

  useEffect(() => {
    getBuildingOptions();
  }, []);

  const { t } = useTranslation();

  return (
    <AdvanceSelector
      notShowLabel
      dimension={t("advanced-search.classroom.forms.building.select-property.placeholder")}
      selectPlaceholder={t("advanced-search.classroom.forms.building.select-value.placeholder")}
      value={buildingOption}
      options={optionsBuilding}
      onChange={onChange}
    />
  );
};

export default AdvancedBuildingSelector;
